import React, { useState } from 'react';
import { NotificationsContext } from 'src/notifications/context/NotificationsContext';
import { ILegacyNotification } from 'src/notifications/models';
import { INotificationConfig } from 'src/notifications/models/INotificationConfig';

const NotificationProvider: React.FC = ({ children }) => {
  const [legacyNotifications, setLegacyNotifications] = useState<ILegacyNotification[]>([]);
  const [notificationConfig, setNotificationConfig] = useState<INotificationConfig>({
    user: null,
    apiToken: '',
    coreApiToken: '',
    graphToken: '',
    userEmail: '',
    notificationApiUrl: '',
    dismissApiUrl: '',
  });
  return (
    <NotificationsContext.Provider
      value={{
        legacyNotifications,
        setLegacyNotifications,
        notificationConfig,
        setNotificationConfig,
      }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export { NotificationProvider };
